export function viewFileByPdfJs(filePath: string) {
  const pdfJsViewer = 'https://mozilla.github.io/pdf.js/web/viewer.html'
  const url = `${pdfJsViewer}?file=${encodeURIComponent(filePath)}`
  window.open(url, '_blank')
}
